import { PerformanceReportResume } from 'types';

export function performanceResumeGetFactory(
  params: any = {}
): PerformanceReportResume {
  const {
    confirmedPercentage,
    confirmedQuantity,
    revokedQuantity,
    timeActionAverage,
  } = params;

  return {
    confirmedPercentage: confirmedPercentage || 0,
    confirmedQuantity: confirmedQuantity || 0,
    revokedQuantity: revokedQuantity || 0,
    timeActionAverage: timeActionAverage || 0,
  };
}
